export default {"src":"/_next/static/media/linkedin-round.2a6f6210.svg","height":50,"width":50};